const $window = $(window);
// const breakPoint = 767;
const breakPoint = 1199;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

let url = location.href;

const setSize= () =>{
  const imgW = 1920;
  const imgH = 1080;
  const winW = $(window).width();
  const winH = $(window).height();
  const scaleW = winW / imgW;
  const scaleH = winH / imgH;
  const fixScale = Math.max(scaleW, scaleH);
  const setW = imgW * fixScale;
  const setH = imgH * fixScale;
  const moveX = Math.floor((winW - setW) / 2);
  const moveY = Math.floor((winH - setH) / 2);

  $('.video').css({
    'width': setW,
    'height': setH,
    'left': moveX,
    // 'top': moveY
  });

  if(windowWidth < 767){
    $('.video').css({
      'width': setW,
      'height': setH,
      'left': moveX,
      // 'top': moveY
    });
  }
}

//export
export { setSize };


// WEBPACK FOOTER //
// ./src/assets/js/include/module.js